import { createSlice } from '@reduxjs/toolkit'

export const BlogViewStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

export const BlogViewRelatedStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    post: {
        postId: null,
        caption: '',
        publishedDate: '',
        imageUrl: '',
        authorImage: '',
        author: '',
    },
    errorMessage: null,
    status: BlogViewStatus.LOADING,
    relatedPosts: [],
    relatedPostsStatus: BlogViewRelatedStatus.LOADING,
    relatedPostsErrorMessage: null,
}

const blogViewSlice = createSlice({
    name: 'blogView',
    initialState,
    reducers: {
        getPostsRequest: state => {
            state.status = BlogViewStatus.LOADING
        },
        getPostsRequestSuccess: (state, action) => {
            state.post = action.payload.post
            state.status = BlogViewStatus.SUCCESS
        },
        getPostsRequestFailure: (state, action) => {
            state.errorMessage = action.payload.error
            state.status = BlogViewStatus.FAILURE
        },
        getRelatedPostsRequest: state => {
            state.relatedPostsStatus = BlogViewRelatedStatus.LOADING
        },
        getRelatedPostsRequestSuccess: (state, action) => {
            state.relatedPosts = action.payload.posts
            state.relatedPostsStatus = BlogViewRelatedStatus.SUCCESS
        },
        getRelatedPostsRequestFailure: (state, action) => {
            state.relatedPostsErrorMessage = action.payload.error
            state.relatedPostsStatus = BlogViewRelatedStatus.FAILURE
        },
        reset: (state, action) => {
            state.status = BlogViewStatus.LOADING
        },
    },
})

const {
    getPostsRequest,
    getPostsRequestFailure,
    getPostsRequestSuccess,
    getRelatedPostsRequest,
    getRelatedPostsRequestSuccess,
    getRelatedPostsRequestFailure,
    reset,
} = blogViewSlice.actions

export const blogViewActions = {
    getPostsRequest,
    getPostsRequestSuccess,
    getPostsRequestFailure,
    getRelatedPostsRequest,
    getRelatedPostsRequestSuccess,
    getRelatedPostsRequestFailure,
    reset,
}

export const blogViewSelectors = {
    getIsFetchingState: state =>
        state.blogView.status === BlogViewStatus.LOADING,
    getPostState: state => state.blogView.post,
    getErrorState: state => state.blogView.errorMessage,
    getRelatedPostsIsFetchingState: state =>
        state.blogView.relatedPostsStatus === BlogViewRelatedStatus.LOADING,
    getRelatedPostsState: state => state.blogView.relatedPosts,
    getRelatedPostsErrorState: state => state.blogView.relatedPostsErrorMessage,
}

export default blogViewSlice.reducer
